import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, Optional, Self } from '@angular/core';
import { AbstractControl, FormControl, NgControl, ValidationErrors } from '@angular/forms';
import { SimpleField } from '../../abstracts';
import { NumberRangeControlConfig } from '../../models/fields/number-range-field-config.model';
import { AnexConfig } from '../../models';
import { untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';

@Component({
  selector: 'fb-number-range-field',
  templateUrl: './number-range-field.component.html',
  styleUrls: ['./number-range-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NumberRangeFieldComponent extends SimpleField<number[] | string[]> implements OnInit {
  @Input() set controls(controls: NumberRangeControlConfig[]) {
    if (!controls?.length) return;
    this.controlsConfig = controls;
  }
  @Input() allowPeriod: boolean = false;
  @Input() suffix: AnexConfig;
  @Input() mask: string;
  @Input() specialCharacters: string[] = [];

  controlsConfig?: NumberRangeControlConfig[];
  form?: FormControl = new FormControl();
  patterns: { [key: string]: { pattern: RegExp } } = {
    N: { pattern: new RegExp('[0-9.]') },
    0: { pattern: new RegExp('[0-9]') },
  };

  constructor(
    protected override changeDetectorRef: ChangeDetectorRef,
    @Optional()
    @Self()
    public override ngControl: NgControl,
  ) {
    super(changeDetectorRef, ngControl);
  }

  ngOnInit(): void {
    this.formToControl(this.ngControl?.value);
    this.form.valueChanges.pipe(untilComponentDestroyed(this)).subscribe((inputValue: string) => {
      const value: object = this.controlToForm(inputValue);
      const control: AbstractControl = this.ngControl.control;
      if (inputValue) {
        control.markAsDirty();
        control.setValue(value);
      }
      const errors: ValidationErrors = { ...this.form.errors };
      if (errors && Object.keys(errors).length > 0) {
        control.setErrors(errors);
      } else {
        control.setErrors(null);
      }
    });
  }

  formToControl<T, K extends keyof T>(formValue: T): void {
    let str: string = '';
    if (!formValue) return;
    this.controlsConfig?.forEach((control: NumberRangeControlConfig) => {
      str += formValue[control.name as K];
      if (control.separator) {
        str += control.separator;
      }
    });
    this.form?.patchValue(str);
  }

  controlToForm<T>(controlValue: string): T {
    const formValue: Partial<T> = {};
    this.controlsConfig?.forEach((control: NumberRangeControlConfig) => {
      const split: string[] = controlValue.split(control.separator);
      formValue[control.name as keyof T] = split[0] as unknown as T[keyof T];
      controlValue = controlValue.slice(split[0].length + control.separator?.length);
    });
    return formValue as T;
  }
}
